import { AppsFlyerApi } from './appsflyer.types';

type BufferedEvent = {
  method: keyof AppsFlyerApi;
  args: unknown[];
};

// This is a buffer of events which will be captured before the init of AppsFlyer
// and after will be sent to the AppsFlyer in the same order.
// Thus we will not lose events.
class AppsFlyerBuffer {
  private buffer: BufferedEvent[] = [];

  queueBufferEvent(method: keyof AppsFlyerApi) {
    return (...args: unknown[]) => {
      this.buffer.push({ method, args });
    };
  }

  sendBufferedEvents(sdk: AppsFlyerApi): void {
    this.buffer.forEach(({ method, args }) => {
      const fn = sdk[method];
      if (typeof fn === 'function') {
        (fn as (...a: unknown[]) => unknown)(...(args ?? []));
      }
    });
  }

  clearBuffer(): void {
    this.buffer.length = 0;
  }
}

export const appsFlyerBuffer = new AppsFlyerBuffer();
